// @flow
import { connect } from 'react-redux';

import PagePartners from 'components/page/template/PagePartners';
import type { StateProps } from 'components/page/template/PagePartners';
import type { StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => ({
    categoriesArticle: state.newsletterState.categoriesArticle,
  }),
  )(PagePartners);
